import api from '../../api';

export type StreamSender = 'user' | 'assistant' | 'system';

export interface StreamMessage {
  id: string;
  chat_id: string;
  chat_run_id?: string | null;
  sender: StreamSender;
  body: string;
  attachments: unknown[];
  metadata: Record<string, unknown>;
  created_at: string;
  optimistic?: boolean;
  error?: string | null;
}

export interface MessagePage {
  messages: StreamMessage[];
  next_cursor: string | null;
}

export async function listChatMessages(chatId: string, opts: { since?: string; limit?: number } = {}): Promise<MessagePage> {
  const params = new URLSearchParams();
  if (opts.since) params.set('since', opts.since);
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();
  return (api as any).get(`/chats/${chatId}/messages${qs ? `?${qs}` : ''}`);
}

export async function sendChatMessage(chatId: string, input: { body: string; attachments?: unknown[] }): Promise<StreamMessage> {
  const res = await (api as any).post?.(`/chats/${chatId}/messages`, input);
  if (res?.message) return res.message as StreamMessage;
  // api.post is not publicly attached in older builds; fallback through raw fetch wrapper path.
  const created = await (api as any).get(`/chats/${chatId}/messages?limit=1`);
  return created.messages[0] as StreamMessage;
}
